/** @jsx jsx */
import { jsx } from "@emotion/react";
import { contentContainer } from "./ContentContainerStyles";
import React from "react";

const ContentContainer = ({ children }) => (
    <div css={contentContainer.container}>
        <div css={contentContainer.inner}>{children}</div>
    </div>
);

export { ContentContainer };
